import { ajax } from 'rxjs/ajax';
import {
  catchError, map, of, switchMap,
} from 'rxjs';

import { ofType } from 'redux-observable';
import {
  LOAD_MAP_GEOJSON,
  loadMapGeoJSONFailure,
  loadMapGeoJSONSuccess,
} from '../ducks/actions/data.js';

const loadMapGeoJson = action$ => action$.pipe(
  ofType(LOAD_MAP_GEOJSON),
  switchMap(action => ajax.getJSON(action.payload).pipe(
    map(newGeojson => loadMapGeoJSONSuccess(newGeojson)),
    catchError(error => of(loadMapGeoJSONFailure(error))),
  )),
);

export const dataActions = [
  loadMapGeoJson,
];
